import React from 'react'
import moment from "moment";
import ExamInstruction from '../../student/ExamInstruction'
import style from './ExamResult.module.css';

const QuestionPaperTestSeries = ({exam,filterAndMapQuestions}) => {
    const getTopicEntries = () =>
        Object.entries(exam.topics || {})
            .map(([subject, topics]) => [subject, Array.isArray(topics) ? topics.filter(Boolean) : []])
            .filter(([, topics]) => topics.length > 0);

    const getQuestionNumber = (subject,index) => {
        const sectionRanges = {
          "Physics": { start: 1, end: 45 },
          "Chemistry": { start: 46, end: 90 },
          "Biology": { start: 91, end: 180 },
        };
      
        const sectionKey = `${subject}`;
        const sectionRange = sectionRanges[sectionKey];
      
        if (sectionRange) {
          return sectionRange.start + index; // Adds the index to the start of the section's range
        }
      
        return null; // If section is not found
      };
    return (
        <div className='times-font'>
            <div className='row' style={{ border: '1px solid black', display: 'flex', alignItems: 'center' }}>
                <div className='col-4 d-flex justify-content-center'>
                    <img src='/assets/images/monoarclogo2.jpeg' width='95%' alt='logo'  className='my-3'/>
                </div>
                <div
                    className='col-5 d-flex flex-column justify-content-center text-center'
                    style={{ borderRight: '1px solid black', borderLeft: '1px solid black', alignSelf: 'stretch', }}
                >
                    <h3 className='fw-bold'>{exam.courseName}</h3>
                </div>
                <div className='col-3 d-flex flex-column justify-content-center fw-bold'>
                    <span>NEET UG</span>
                    <span>{exam.className}</span>
                    <span>Date : {moment(exam.startDate).format('DD MMMM YYYY')}</span>
                </div>
            </div>
            <div className='row' style={{borderRight: '1px solid black', borderLeft: '1px solid black'}}>
                <h4 className="text-center py-1 fw-bold" style={{ borderBottom: '1px solid black' }}>{exam.examName}</h4>
                <div className='d-flex justify-content-between'>
                    <span>Marks : 720</span><span>Time : 180 mins</span>
                </div>
                {getTopicEntries().length > 0 && (
                    <div style={{ borderTop: '1px solid black', padding: '5px' }}>
                        <strong>Topics Included :</strong>
                        {getTopicEntries().map(([subject, topics]) => (
                            <div key={subject}>
                                <span className="fw-bold">{subject}: </span>
                                <span>{topics.join(", ")}</span>
                            </div>
                        ))}
                    </div>
                )}
                <div style={{ borderTop: '1px solid black',borderBottom: '1px solid black', padding: '5px' }}>
                    <strong>Important Instructions :</strong>
                    <ExamInstruction />
                </div>
            </div>
            <div className='row' style={{borderRight:'1px solid black',borderLeft:'1px solid black',borderBottom:'1px solid black'}}>
            {filterAndMapQuestions("Physics") && (
                        <div className='px-0'>
                            <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Physics</h5>
                            {filterAndMapQuestions("Physics").map((q, i) => (
                                <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                    <div className="d-flex"
                                        dangerouslySetInnerHTML={{
                                            __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                        }}
                                    >
                                    </div>
                                    <div className="d-flex flex-wrap">
                                        {q.options.map((o, i) => (
                                            <span key={i} className="ms-4 d-flex"
                                                dangerouslySetInnerHTML={{
                                                    __html: `<p class='mr-2'>(${i + 1})</p> ${o}`
                                                }}
                                            >
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
            <div className='row' style={{borderRight:'1px solid black',borderLeft:'1px solid black',borderBottom:'1px solid black'}}>
            {filterAndMapQuestions("Chemistry") && (
                        <div className='px-0'>
                            <h5 className="text-center fw-bold" style={{borderBottom: '1px solid black' }}>Chemistry</h5>
                            {filterAndMapQuestions("Chemistry").map((q, i) => (
                                <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                    <div className="d-flex"
                                        dangerouslySetInnerHTML={{
                                            __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                        }}
                                    >
                                    </div>
                                    <div className="d-flex flex-wrap">
                                    {q.options.map((o, i) => (
                                        <span key={i} className="ms-4 d-flex"
                                            dangerouslySetInnerHTML={{
                                                __html: `<p class='mr-2'>(${i + 1})</p> ${o}`
                                            }}
                                        >
                                        </span>
                                    ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
            <div className='row' style={{borderLeft:'1px solid black'}}>
            {filterAndMapQuestions("Biology") && (
                        <div className='px-0'>
                            <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Biology</h5>
                            {filterAndMapQuestions("Biology").map((q, i) => (
                                <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                    <div className="d-flex"
                                        dangerouslySetInnerHTML={{
                                            __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                        }}
                                    >
                                    </div>
                                    <div className="d-flex flex-wrap">
                                    {q.options.map((o, i) => (
                                        <span key={i} className="ms-4 d-flex align-items-start"
                                            dangerouslySetInnerHTML={{
                                                __html: `<p class='mr-2'>(${i + 1})</p> ${o}`
                                            }}
                                        >
                                        </span>
                                    ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
        </div>
    )
}

export default QuestionPaperTestSeries
